import { Injectable } from '@angular/core';
import { HttpErrorsService } from '../alerts/errors/http-errors.service';
import { ConectarApiService } from '../api/connection/conectar-api.service';


@Injectable({
  providedIn: 'root'
})
export class GlobalServicCentros {
  tipoCentros: any;
  centrosasociados: any;

  constructor(private servicioAPI: ConectarApiService,private httpErrorService: HttpErrorsService) { }

/*     settipoCentros (tc) {
      this.tipoCentros = tc;
      this.centrosasociados = tc;
    }
 */

  async getCentros(){
    const cached = localStorage.getItem("CentrosIds");
    const parsed = cached ? (() => { try { return JSON.parse(cached); } catch { return null; } })() : null;
    const isListaObjetos = parsed && Array.isArray(parsed) && parsed.length > 0 &&
      (typeof parsed[0] === "object" && parsed[0] !== null && (parsed[0].Nombre != null || parsed[0].pkId != null || parsed[0].Id != null));
    if (isListaObjetos) {
      this.tipoCentros = parsed;
      this.centrosasociados = this.tipoCentros;
    } else {
      await this.servicioAPI.getCentrosAsync().then(data => {
        let CentrosAPI = data;
        this.tipoCentros = [];
        const lista = CentrosAPI?.DatosResult?.ListaCentros ?? CentrosAPI?.DatosResult?.Lista ?? null;
        if (lista != null && Array.isArray(lista)) {
          this.tipoCentros = lista;
          this.centrosasociados = this.tipoCentros;
        }
      },
        error => { this.httpErrorService.identificarErrores(error); }
      );
    }
  }
/*     setcentrosasociados(sa) {
      this.centrosasociados = sa;
    } */

    //centros
    filtrarTiposCentros() {
      // return this.tipoCentros.filter(x => x.Activo == "True");
      let respuesta = [];
      let Centros = []
      if (this.tipoCentros) Centros = this.tipoCentros.filter(x => x.Activo == "True");
      let tmpCentrosAsociados = this.tipoCentros;
      if (Centros != null && Centros.length > 0) {
        respuesta = Centros.filter(function (item) {
          return tmpCentrosAsociados.findIndex(function (itemSub) { return itemSub == item.pkId }) === -1;
        });
      }
      else {
        if (this.tipoCentros) respuesta = this.tipoCentros.filter(x => x.Activo == "True");
      }
      return respuesta;
    }
  
    comparaObjetosSelect(o1: any, o2: any) {
      return o1 && o2 ? o1.id === o2.id || o1 === o2.id || o1.id === o2 : o1 === o2;
    }
    asignarTipoCentro(item, evento) {
      this.centrosasociados.push(item.pkId);
    }
    desasignarTipoCentro(item, evento) {
      let arrtemp = [];
      arrtemp = this.centrosasociados.filter(function (x) { return x != item.pkId });
      this.centrosasociados = arrtemp;
  
    }
  
    deasignarTodosCentros() {
      this.centrosasociados = [];
    }
    asignarTodosCentros() {
      this.centrosasociados = this.tipoCentros.filter(x => x.Activo == "True").map(function (x) { return x.pkId });
    }
  
    
    obtenercentrosAsociadosconOrden(centrosAsignados: any, orderField?: string): string {
    
      if (!centrosAsignados || !Array.isArray(centrosAsignados) || centrosAsignados.length === 0) {
        return "";
      }

      const resolveId = (centro: any): string | null => {
        if (centro == null) return null;
        if (typeof centro === "string" || typeof centro === "number") return String(centro).trim();
        const raw =
          centro.iCentro ??
          centro.iCentroId ??
          centro.pkId ??
          centro._id ??
          centro.id ??
          centro.PkId ??
          centro.pkid ??
          centro.CentroId ??
          centro.Id;
        if (raw == null) return null;
        const s = String(raw).trim();
        return s.length ? s : null;
      };

      if (orderField) {
        const parts: string[] = [];
        const seen = new Set<string>();
        centrosAsignados.forEach((centro: any) => {
          const id = resolveId(centro);
          if (!id || seen.has(id)) return;
          seen.add(id);
          let orden = 0;
          if (centro && typeof centro === "object") {
            const o = centro[orderField];
            const n = Number(o);
            orden = Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0;
          }
          parts.push(`${id}:${orden}`);
        });
        return parts.join(",");
      }

      const ids = centrosAsignados
        .map((centro: any) => resolveId(centro))
        .filter((x: string | null): x is string => !!x);

      const seen = new Set<string>();
      const uniq = ids.filter((id) => {
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
      });

      return uniq.join(",");
    }

    private _getIdCentro(centro: any): string | null {
      if (!centro || typeof centro !== "object") return null;
      const raw =
        centro.iCentro ??
        centro.iCentroId ??
        centro.pkId ??
        centro.PkId ??
        centro.Id ??
        centro.id ??
        centro.CentroId ??
        centro.pkid;
      if (raw == null) return null;
      const s = String(raw).trim();
      return s.length ? s : null;
    }

    private _centroCoincideId(centro: any, idStr: string): boolean {
      if (!centro || typeof centro !== "object") return false;
      const keys = [
        centro.iCentro,
        centro.iCentroId,
        centro.pkId,
        centro.PkId,
        centro.Id,
        centro.id,
        centro.CentroId,
        centro.pkid,
      ];
      return keys.some(
        (v) =>
          v != null &&
          v !== "" &&
          String(v).trim() === idStr
      );
    }
    private _parseCentrosAsociadosOrden(centrosAsociadosStr: string): Map<string, number> {
      const mapa = new Map<string, number>();
      if (!centrosAsociadosStr || typeof centrosAsociadosStr !== "string") {
        return mapa;
      }
      centrosAsociadosStr.split(",").forEach((seg) => {
        const s = seg.trim();
        if (!s || !s.includes(":")) return;
        const parts = s.split(":");
        const id = (parts[0] ?? "").trim();
        const n = parseInt(parts[1] ?? "0", 10);
        if (!id) return;
        mapa.set(id, Number.isFinite(n) && n >= 0 ? n : 0);
      });
      return mapa;
    }

    daTiposCentros(registroComponente): any[] {
      let respuesta = [];
      const centrosIdsStr = registroComponente?.CentrosIds ?? registroComponente?.centrosIds ?? "";
      const centrosAsociadosStr =
        registroComponente?.CentrosAsociados ?? registroComponente?.centrosAsociados ?? "";

      const ordenPorCentro = this._parseCentrosAsociadosOrden(centrosAsociadosStr);

      if (!centrosIdsStr || typeof centrosIdsStr !== "string") return respuesta;

      const arrayCentrosString = centrosIdsStr.split(",")
        .map((id: any) => (id != null ? String(id).trim() : ""))
        .filter((id: string) => id.length > 0);

      if (arrayCentrosString.length === 0) return respuesta;

      const nombresApi = String(
        registroComponente?.CentrosNombres ?? registroComponente?.centrosNombres ?? ""
      )
        .split(",")
        .map((s: string) => s.trim());

      const allCentros = (this.tipoCentros && Array.isArray(this.tipoCentros))
        ? this.tipoCentros.filter((x: any) => !x || x.Activo == "True" || x.Activo === true)
        : [];

      arrayCentrosString.forEach((segment: string, index: number) => {
        let centropkId = segment.trim();
        let ordenCategoria = 0;
        if (centropkId.includes(":")) {
          const parts = centropkId.split(":");
          centropkId = (parts[0] ?? "").trim();
          const n = parseInt(parts[1] ?? "0", 10);
          ordenCategoria = Number.isFinite(n) && n >= 0 ? n : 0;
        } else if (ordenPorCentro.has(centropkId)) {
          ordenCategoria = ordenPorCentro.get(centropkId) ?? 0;
        }
        if (!centropkId) return;
        const act = allCentros.find((find: any) =>
          this._centroCoincideId(find, centropkId)
        );
        if (act) {
          respuesta.push({ ...act, ordenCategoria });
        } else {
          const nombreStub =
            nombresApi[index] && nombresApi[index].length > 0
              ? nombresApi[index]
              : "Centro " + centropkId;
          respuesta.push({
            pkId: centropkId,
            iCentro: centropkId,
            Nombre: nombreStub,
            ordenCategoria,
          });
        }
      });

      return respuesta;
    }

    //centros

}
